import {
    IonPage, IonContent, IonInput, IonTitle, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {uploadImage} from "../../../../utils/uploadPic";
import {AccountSuggest} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import Script from "react-load-script";
import {getQueryVariable} from "../../../../utils/commonFunction";


class PhoneSuggest extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            djs: '',
            isAgree: false,
            isPicUpload: false,
            picType: 0,
            selectedPic: [],
            selectedImages: [],
            suggestType: '账号问题',
            content: '',
            token: null,
            qqNumber: '',
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[1-9]\d{3,9}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
        if (cookieUtil.has("userInfo")) {
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            //console.log(userInfoJson);
            this.setState({account: userInfoJson.userGameId})
        }
        // 兼容公众号个人中心--举报建议跳转至该页面
        let userGameId = getQueryVariable('userGameId');
        if (userGameId !== null && userGameId !== '' && userGameId !== '0') {
            this.setState({account: userGameId})
        }
    }

    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        this.setState({
            phoneTip: phoneTip,
        })

    };

    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }


    submitMsg = () => {
        const {account, suggestType, phone, selectedPic, content, qqNumber} = this.state;
        if (account === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写游戏账号'
            })
            return;
        }

        if (!this.regCode.test(qqNumber)) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写有效QQ，以便官方联系'
            })

            return;
        }

        if (!this.regPhone.test(phone)) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写正确手机号，以便官方发放流量奖励'
            })

            return;
        }

        if (selectedPic.length == 0) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传截图'
            })

            return;
        }


        if (content === '' || content.length < 10) {
            this.setState({isShowTip: true, showTipMsg: '问题（如操作过程、发生异常的情况等），至少输入10个汉字'})
            return;
        }


        //处理图片
        let picUrls = '';
        if (selectedPic.length > 0) {
            for (let i = 0; i < selectedPic.length; i++) {
                if (i === 0) {
                    picUrls = selectedPic[i]
                } else {
                    picUrls = picUrls + ";" + selectedPic[i]
                }
            }
        }

        const _that = this;
        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            if (res.ret === 0) {

                const params = {
                    'accounts': account,
                    'qqNumber': qqNumber,
                    'phone': phone,
                    'picUrl': picUrls,
                    'content': content,
                    'suggestType': suggestType,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }

                AccountSuggest(params).then(ret => {
                    if (ret.code === '10000') {
                        console.log(ret.data);
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.data
                        })
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                    }
                    captcha1.destroy();
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }


    /**
     * 图片上传
     * @param type  1充值截图 2监护人户口页 3未成年户口页 4出生或监护证明 5举证材料
     * @param event
     * @returns {Promise<void>}
     */
    handleFileInputChange = async (type, event) => {
        const {
            selectedImages,
            selectedPic,
        } = this.state;

        const fileList = event.target.files;
        //console.log(fileList);
        let images = [];
        switch (type) {
            case 1:
                if (selectedImages.length + fileList.length > 5) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传5张图片,请重新选择！'})
                    return;
                }
                images = selectedImages;
                break;
        }

        let isJpgOrPng = true;
        let isLt2M = true;
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            //console.log(file)
            isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.setState({isShowTip: true, showTipMsg: '只能上传JPG/PNG格式的图片'})
                return;
            }
            isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.setState({isShowTip: true, showTipMsg: '上传图片不能大于10MB'})
                return;
            }
        }

        let realImageUrls = [];

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const reader = new FileReader();
            const params = {
                file: file,
                path: 'pc/accountRefund'
            }
            const imageUrl = await uploadImage(params);
            if (imageUrl === "" || imageUrl === null) {
                this.setState({isShowTip: true, showTipMsg: '图片上传失败'})
                return;
            }
            //console.log("imageUrl:" + imageUrl)
            realImageUrls = imageUrl
            if (type === 1) {
                selectedPic.push(imageUrl);
                realImageUrls = selectedPic;
            }

            reader.onload = (event) => {
                images.push(event.target.result);
                if (i === fileList.length - 1) {
                    switch (type) {
                        case 1:
                            this.setState({selectedImages: images, selectedPic: realImageUrls})
                            break;
                    }
                }
            };
            await reader.readAsDataURL(file);
        }
    }

    /**
     * 删除图片
     * @param index
     */
    handleImageDelete = (index, type) => {
        const {
            selectedImages,
            selectedPic,
        } = this.state;

        let images = [];
        let realImages = [];
        switch (type) {
            case 1:
                images = [...selectedImages];
                realImages = [...selectedPic];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedImages: images, selectedPic: realImages})
                break;
        }
    };

    returnPage = () => {
        const {isPicUpload} = this.state;
        if (isPicUpload) {
            this.setState({isPicUpload: false})
        }
    }
    /**
     * 图片上传页面展示
     * @param type
     */
    uploadPage = (type) => {
        this.setState({
            isPicUpload: true,
            picType: type
        })
    }

    /**
     * 上图图片按钮触发
     * @param idx
     */
    uploadBtnLoad = (idx) => {
        const uploadInput = document.getElementById('upload_' + idx);
        uploadInput.click();
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    render() {

        const {
            phone,
            account,
            content,
            isPicUpload,
            picType,
            selectedPic,
            selectedImages,
            suggestType,
            qqNumber,
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    {isPicUpload ?
                        <div className="sut_cont bggray">
                            <div className="phone_top pr">
                                <a className="xya_return" onClick={() => this.returnPage()}>
                                    <img src={require("../../../images/member/refund/return_icon.png")}/>
                                </a>
                                {picType === 1 && <div className="top_title">建议截图</div>}
                                {picType === 2 && <div className="top_title">问题类型</div>}

                            </div>
                            <div className="sut_box">
                                {picType === 1 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('pay')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{selectedImages.length}/5</p>
                                            </a>

                                        </div>
                                        {selectedImages.length > 0 && selectedImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 1)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/5</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {picType === 2 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <div className="radio_cont_kf clearfix">
                                                <label className="w160p">
                                                    <input type="radio" name="type" checked={suggestType === '账号问题'}
                                                           onChange={e => this.setState({suggestType: '账号问题'})}
                                                           className="radio"/>账号问题
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '游戏异常'}
                                                           onChange={() => this.setState({suggestType: '游戏异常'})}
                                                           name="type" className="radio"/>游戏异常
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '改进建议'}
                                                           onChange={() => this.setState({suggestType: '改进建议'})}
                                                           name="type" className="radio"/>改进建议
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '充值'}
                                                           onChange={() => this.setState({suggestType: '充值'})}
                                                           name="type" className="radio"/>充值
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '咨询'}
                                                           onChange={() => this.setState({suggestType: '咨询'})}
                                                           name="type" className="radio"/>咨询
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '举报投诉'}
                                                           onChange={() => this.setState({suggestType: '举报投诉'})}
                                                           name="type" className="radio"/>举报投诉
                                                </label>
                                                <label className="w160p">
                                                    <input type="radio" checked={suggestType === '其它'}
                                                           onChange={() => this.setState({suggestType: '其它'})}
                                                           name="type" className="radio"/>其它
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <input id="upload_pay" type="file" onChange={e => this.handleFileInputChange(1, e)}
                                       className="file dn" accept="image/*" multiple/>

                            </div>
                        </div> :
                        <div className="sut_cont bggray">
                            <div className={"phone_top pr border-bottom-e6"}>
                                <div className="top_title">投诉建议</div>
                            </div>
                            <Script
                                url={captchaUrl()}
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="cont_kf">
                                <div className="point_tex">
                                    <p>如您游戏体验过程中遇见任何问题或好的建议，均可向我们反馈，一经采纳将给予游戏道具奖励！</p>
                                </div>

                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">* 游戏账号或ID</span>
                                    <input type="text" className="input-tex4"
                                           placeholder="第三方账号请填写游戏ID "
                                           value={account}
                                           onChange={e => this.setState({account: e.target.value})}/>
                                </div>

                                <div className="clearfix pr phone_identity">
                                    <a className="upload_icon1" onClick={() => this.uploadPage(2)}>
                                        <span className="w246 ml30">* 问题类型</span>
                                        <img src={require("../../../images/member/refund/jt_icon.png")}/>
                                    </a>
                                    <p className="upload_tex1 pa">{suggestType}</p>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">* QQ</span>
                                    <input type="text" className="input-tex4"
                                           value={qqNumber}
                                           onChange={e => {
                                               this.setState({qqNumber: e.target.value})
                                           }}
                                           placeholder="填写正确QQ"/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">* 联系手机</span>
                                    <input type="text" className="input-tex4"
                                           value={phone}
                                           onChange={e => {
                                               this.setState({phone: e.target.value})
                                           }}
                                           placeholder="填写正确手机号"/>
                                </div>

                                <div className="clearfix pr phone_identity" onClick={() => this.uploadPage(1)}>
                                    <span className="w246 ml30">* 上传截图</span>
                                    <a className="upload_icon1">
                                        <img src={require("../../../images/member/refund/jt_icon.png")}/></a>
                                    {selectedPic.length > 0 && <p className="upload_tex1 pa">已上传</p>}
                                </div>

                                <div className="clearfix pr phone_identity bbn">
                                    <span className="w246 ml30">* 反馈内容</span>
                                    <textarea name="textarea" id="textarea"
                                              value={content}
                                              onChange={e => {
                                                  this.setState({content: e.target.value})
                                              }}
                                              className="textarea"
                                              placeholder={"提示：请尽可能描述您所发现的问题（如操作过程发生异常的情况等），至少输入10个汉字。"}> </textarea>
                                </div>

                                <a className="btn_kf mt100" onClick={this.submitMsg}>提交</a>
                                <a href="/phone/badInformation" className="Bad_infor">不良信息反馈</a>

                            </div>
                        </div>
                    }

                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(PhoneSuggest);
